import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import AdminSidebar from "../components/AdminSidebar";
import {useGoogleMaps, Marker, EnhancedGoogleMap} from './../useGoogleMaps';import './DriverManagement.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import carGreen from '../assets/1.png';  // استيراد صورة السيارة الخضراء (متاح)
import carBlue from '../assets/2.png';   // استيراد صورة السيارة الزرقاء (في الطريق)
import carRed from '../assets/3.png'; 
// تهيئة مفتاح Mapbox
mapboxgl.accessToken = 'pk.eyJ1IjoibXJjY2NyZXciLCJhIjoiY204ZG1kNGx0MmVlZDJqcXU4a25xbGRibCJ9.hoeEc8I4yW_fg0ZBOWD9LA';

// استيراد الصور مباشرة من مجلد الأصول (بافتراض أن لديك هذه الملفات)
   // استيراد صورة السيارة الحمراء (متوقف)

const MapboxAddressSearch = ({ onSelect }) => {
  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);

  const searchAddresses = async (input) => {
    if (input.length < 3) return;

    setLoading(true);
    try {
      const response = await fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(input)}.json?` +
        `access_token=${mapboxgl.accessToken}&` +
        `country=KW&` + // تخصيص البحث للكويت
        `language=ar`
      );

      const data = await response.json();
      setSuggestions(data.features);
      setLoading(false);
    } catch (error) {
      console.error('خطأ في البحث:', error);
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    searchAddresses(value);
  };

  const handleSelectAddress = (address) => {
    setQuery(address.place_name);
    onSelect({
      address: address.place_name,
      location: {
        lat: address.center[1],
        lng: address.center[0]
      }
    });
    setSuggestions([]);
  };

  return (
    <div className="address-search-container">
      <input
        type="text"
        value={query}
        onChange={handleInputChange}
        placeholder="ابحث عن العنوان في الكويت"
        className="address-input"
      />
      {loading && <div className="search-loading">جاري البحث...</div>}
      {suggestions.length > 0 && (
        <ul className="suggestions-list">
          {suggestions.map((suggestion, index) => (
            <li 
              key={index}
              onClick={() => handleSelectAddress(suggestion)}
              className="suggestion-item"
            >
              {suggestion.place_name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

const DriverManagement = () => {
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingDriver, setEditingDriver] = useState(null);
  const [updatedData, setUpdatedData] = useState({});
  const [newDriver, setNewDriver] = useState({
    name: "",
    email: "",
    phone: "",
    balance: 0,
    status: "متاح",
    address: "",
    location: { lat: 29.3759, lng: 47.9774 },
  });
  const [activeTab, setActiveTab] = useState('map'); // 'map' or 'form'

  const { isLoaded, loadError } = useGoogleMaps();

  // جلب بيانات السائقين عند تحميل المكون
  useEffect(() => {
    fetchDrivers();
  }, []);

  // استرجاع بيانات السائقين من Firestore
  const fetchDrivers = async () => {
    try {
      setLoading(true);
      console.log("📌 جاري جلب بيانات السائقين...");
      const querySnapshot = await getDocs(collection(db, "drivers"));

      if (querySnapshot.empty) {
        console.warn("⚠️ لا توجد بيانات متاحة في Firestore.");
        setDrivers([]);
      } else {
        const data = querySnapshot.docs.map((doc) => {
          const driver = doc.data();
          return {
            id: doc.id,
            ...driver,
            location: driver.location && driver.location.lat && driver.location.lng
              ? driver.location
              : { lat: 29.3759, lng: 47.9774 },
            isMoving: driver.isMoving ?? false,
            speed: driver.speed || 0,
            orderStatus: driver.orderStatus || 'لا يوجد طلب',
            lastUpdate: driver.lastUpdate?.toDate?.() || new Date(),
          };
        });
        console.log("📌 البيانات المسترجعة:", data);
        setDrivers(data);
      }
    } catch (error) {
      console.error("❌ خطأ في جلب بيانات السائقين:", error.message);
    } finally {
      setLoading(false);
    }
  };

  // معالجة اختيار العنوان
  const handleAddressSelect = (selectedAddress) => {
    setNewDriver({
      ...newDriver,
      address: selectedAddress.address,
      location: {
        lat: selectedAddress.location.lat,
        lng: selectedAddress.location.lng
      }
    });
  };

  // تحديد نوع أيقونة السيارة بناءً على حالة السائق
  const getDriverIconUrl = (driver) => {
    if (!driver.isMoving) {
      return carRed; // السائق متوقف
    } else if (driver.orderStatus === 'في الطريق') {
      return carBlue; // السائق في الطريق
    } else {
      return carGreen; // السائق متاح ويتحرك
    }
  };

  // إضافة سائق جديد
  const addDriver = async () => {
    if (!newDriver.name || !newDriver.email || !newDriver.phone) {
      alert("❌ يجب ملء الحقول الأساسية (الاسم، البريد الإلكتروني، الهاتف)!");
      return;
    }

    try {
      setLoading(true);
      
      // إعداد بيانات السائق مع القيم الافتراضية المناسبة
      const driverData = {
        ...newDriver,
        status: "متاح",
        isAvailable: true,
        isMoving: false,
        speed: 0,
        orderStatus: "لا يوجد طلب",
        lastUpdate: new Date(),
        createdAt: new Date(),
      };
      
      // إضافة السائق إلى قاعدة البيانات
      const docRef = await addDoc(collection(db, "drivers"), driverData);
      
      // إضافة السائق للقائمة المحلية
      setDrivers([...drivers, { id: docRef.id, ...driverData }]);
      
      alert("✅ تم إضافة السائق بنجاح!");
      
      // إعادة تعيين نموذج إضافة سائق جديد
      setNewDriver({
        name: "",
        email: "",
        phone: "",
        address: "",
        balance: 0,
        status: "متاح",
        location: { lat: 29.3759, lng: 47.9774 },
      });
      
      // الانتقال إلى تبويب الخريطة لعرض السائق الجديد
      setActiveTab('map');
    } catch (error) {
      console.error("❌ خطأ في إضافة السائق:", error.message);
      alert("❌ حدث خطأ أثناء إضافة السائق: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  // تعديل بيانات السائق
  const startEditing = (driver) => {
    setEditingDriver(driver.id);
    setUpdatedData({
      name: driver.name,
      phone: driver.phone,
      email: driver.email,
      balance: driver.balance || 0,
      address: driver.address || '',
      status: driver.status || 'متاح',
      location: driver.location || { lat: 29.3759, lng: 47.9774 },
    });
  };

  const saveChanges = async () => {
    if (!updatedData.name || !updatedData.phone) {
      alert("❌ يرجى ملء الحقول المطلوبة (الاسم ورقم الهاتف)!");
      return;
    }

    try {
      setLoading(true);
      await updateDoc(doc(db, "drivers", editingDriver), updatedData);
      
      // تحديث البيانات محلياً بعد تحديثها في قاعدة البيانات
      setDrivers((prev) =>
        prev.map((d) => (d.id === editingDriver ? { ...d, ...updatedData } : d))
      );
      
      setEditingDriver(null);
      alert("✅ تم تعديل بيانات السائق بنجاح!");
    } catch (error) {
      console.error("❌ خطأ في تعديل السائق:", error.message);
      alert("❌ حدث خطأ أثناء تعديل بيانات السائق: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  // تحديث حالة السائق (متاح/غير متاح)
  const toggleDriverStatus = async (driver) => {
    try {
      setLoading(true);
      const newStatus = driver.status === "متاح" ? "غير متاح" : "متاح";
      
      // تحديث الحالة في Firestore
      await updateDoc(doc(db, "drivers", driver.id), { 
        status: newStatus,
        isAvailable: newStatus === "متاح" ? true : false
      });
      
      // تحديث حالة السائق محلياً
      setDrivers((prev) =>
        prev.map((d) => (d.id === driver.id ? { 
          ...d, 
          status: newStatus,
          isAvailable: newStatus === "متاح" ? true : false
        } : d))
      );
      
      alert(`✅ تم ${newStatus === "متاح" ? "تفعيل" : "إيقاف"} السائق بنجاح!`);
    } catch (error) {
      console.error("❌ خطأ في تحديث حالة السائق:", error.message);
      alert("❌ حدث خطأ أثناء تحديث حالة السائق: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  // حذف سائق
  const deleteDriver = async (driverId) => {
    if (window.confirm("هل أنت متأكد أنك تريد حذف هذا السائق؟")) {
      try {
        setLoading(true);
        
        // حذف السائق من قاعدة البيانات
        await deleteDoc(doc(db, "drivers", driverId));
        
        // حذف السائق من القائمة المحلية
        setDrivers(drivers.filter((d) => d.id !== driverId));
        
        alert("✅ تم حذف السائق بنجاح!");
      } catch (error) {
        console.error("❌ خطأ في حذف السائق:", error.message);
        alert("❌ حدث خطأ أثناء حذف السائق: " + error.message);
      } finally {
        setLoading(false);
      }
    }
  };

  // إذا كان هناك خطأ في تحميل الخريطة
  if (loadError) {
    return (
      <div>
        <Header />
        <div className="error-container">
          <h2>خطأ في تحميل الخريطة</h2>
          <p>{loadError.message}</p>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="driver-management-layout">
      <AdminSidebar />
      {loading && (
        <div className="loading-overlay">
          <div className="spinner"></div>
        </div>
      )}
      
      <div className="driver-management-content">
        <div className="driver-management-header">
          <h1>إدارة السائقين</h1>
          <div className="tab-selector">
            <button 
              className={`tab-button ${activeTab === 'map' ? 'active' : ''}`}
              onClick={() => setActiveTab('map')}
            >
              الخريطة
            </button>
            <button 
              className={`tab-button ${activeTab === 'form' ? 'active' : ''}`}
              onClick={() => setActiveTab('form')}
            >
              إضافة سائق
            </button>
          </div>
        </div>

        <div className="dashboard-container">
          {activeTab === 'map' ? (
            <div className="map-and-table">
              <div className="map-container">
                <div className="map-legend">
                  <div className="legend-item">
                    <div className="legend-color green"></div>
                    <span>متاح ويتحرك</span>
                  </div>
                  <div className="legend-item">
                    <div className="legend-color blue"></div>
                    <span>في الطريق</span>
                  </div>
                  <div className="legend-item">
                    <div className="legend-color red"></div>
                    <span>متوقف</span>
                  </div>
                </div>
                {isLoaded ? (
                  // استخدام EnhancedGoogleMap بدلاً من GoogleMap العادية
                  <EnhancedGoogleMap 
                    center={{ lat: 29.3759, lng: 47.9774 }} 
                    zoom={12}
                    options={{
                      // إضافة خيارات لتحسين أداء الخريطة وتقليل الأخطاء
                      disableDefaultUI: false,
                      zoomControl: true,
                      fullscreenControl: false,
                      clickableIcons: false
                    }}
                  >
                    {drivers.map((driver) =>
                      driver.location && driver.location.lat && driver.location.lng ? (
                        <Marker 
                          key={driver.id} 
                          position={driver.location}
                          icon={{
                            url: getDriverIconUrl(driver),
                            scaledSize: { width: 50, height: 50 },
                            anchor: { x: 25, y: 50 }
                          }}
                        />
                      ) : null
                    )}
                  </EnhancedGoogleMap>
                ) : (
                  <div className="map-loading">
                    <p>جاري تحميل الخريطة...</p>
                  </div>
                )}
              </div>

              <div className="card driver-list-section">
                <div className="card-header">
                  <h2>قائمة السائقين</h2>
                  <div className="driver-stats">
                    <div className="stat">
                      <span className="stat-value">{drivers.length}</span>
                      <span className="stat-label">إجمالي السائقين</span>
                    </div>
                    <div className="stat">
                      <span className="stat-value">{drivers.filter(d => d.status === "متاح").length}</span>
                      <span className="stat-label">سائقين متاحين</span>
                    </div>
                  </div>
                </div>

                {drivers.length === 0 ? (
                  <div className="no-data">
                    <div className="no-data-icon">🚫</div>
                    <p>لا يوجد سائقين متاحين حالياً.</p>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="driver-table">
                      <thead>
                        <tr>
                          <th>الاسم</th>
                          <th>الهاتف</th>
                          <th>الحالة</th>
                          <th>الإجراءات</th>
                        </tr>
                      </thead>
                      <tbody>
                        {drivers.map((driver) => (
                          <React.Fragment key={driver.id}>
                            <tr className={editingDriver === driver.id ? 'selected-row' : ''}>
                              <td>{driver.name}</td>
                              <td>{driver.phone}</td>
                              <td>
                                <span className={`status-badge ${driver.status === "متاح" ? 'available' : 'unavailable'}`}>
                                  {driver.status}
                                </span>
                              </td>
                              <td className="actions-cell">
                                <button 
                                  className="action-button edit"
                                  onClick={() => startEditing(driver)}
                                >
                                  تعديل
                                </button>
                                {editingDriver === driver.id && (
                                  <button 
                                    className="action-button save"
                                    onClick={saveChanges}
                                  >
                                    حفظ
                                  </button>
                                )}
                                <button 
                                  className="action-button toggle"
                                  onClick={() => toggleDriverStatus(driver)}
                                >
                                  {driver.status === "متاح" ? "إيقاف" : "تفعيل"}
                                </button>
                                <button 
                                  className="action-button delete"
                                  onClick={() => deleteDriver(driver.id)}
                                >
                                  حذف
                                </button>
                              </td>
                            </tr>
                            {editingDriver === driver.id && (
                              <tr className="editing-row">
                                <td colSpan="4">
                                  <div className="editing-form">
                                    <div className="form-row">
                                      <label>الاسم:</label>
                                      <input 
                                        type="text" 
                                        value={updatedData.name || ''} 
                                        onChange={(e) => setUpdatedData({...updatedData, name: e.target.value})}
                                      />
                                    </div>
                                    <div className="form-row">
                                      <label>الهاتف:</label>
                                      <input 
                                        type="text" 
                                        value={updatedData.phone || ''} 
                                        onChange={(e) => setUpdatedData({...updatedData, phone: e.target.value})}
                                      />
                                    </div>
                                    <div className="form-row">
                                      <label>العنوان:</label>
                                      <input 
                                        type="text" 
                                        value={updatedData.address || ''} 
                                        onChange={(e) => setUpdatedData({...updatedData, address: e.target.value})}
                                      />
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="add-driver-section">
              <div className="card">
                <div className="card-header">
                  <h2>إضافة سائق جديد</h2>
                </div>
                <div className="card-body">
                  <div className="form-grid">
                    <div className="form-group">
                      <label>اسم السائق</label>
                      <input 
                        type="text" 
                        placeholder="أدخل اسم السائق" 
                        value={newDriver.name} 
                        onChange={(e) => setNewDriver({ ...newDriver, name: e.target.value })}
                        className="form-control"
                      />
                    </div>
                    <div className="form-group">
                      <label>البريد الإلكتروني</label>
                      <input 
                        type="email" 
                        placeholder="أدخل البريد الإلكتروني" 
                        value={newDriver.email} 
                        onChange={(e) => setNewDriver({ ...newDriver, email: e.target.value })}
                        className="form-control"
                      />
                    </div>
                    <div className="form-group">
                      <label>رقم الهاتف</label>
                      <input 
                        type="text" 
                        placeholder="أدخل رقم الهاتف" 
                        value={newDriver.phone} 
                        onChange={(e) => setNewDriver({ ...newDriver, phone: e.target.value })}
                        className="form-control"
                      />
                    </div>
                    <div className="form-group">
                      <label>الرصيد</label>
                      <input 
                        type="number" 
                        placeholder="أدخل الرصيد" 
                        value={newDriver.balance} 
                        onChange={(e) => setNewDriver({ ...newDriver, balance: Number(e.target.value) })}
                        className="form-control"
                      />
                    </div>
                    <div className="form-group full-width">
                      <label>العنوان</label>
                      <MapboxAddressSearch onSelect={handleAddressSelect} />
                      {newDriver.address && (
                        <div className="selected-address">
                          <strong>العنوان المختار:</strong> {newDriver.address}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="form-actions">
                    <button 
                      className="add-button"
                      onClick={addDriver} 
                      disabled={loading}
                    >
                      إضافة السائق
                    </button>
                  </div>
                </div>
              </div>
              
              {isLoaded && (
                <div className="preview-map-container card">
                  <div className="card-header">
                    <h2>موقع السائق على الخريطة</h2>
                  </div>
                  <EnhancedGoogleMap 
                    center={newDriver.location}
                    zoom={15}
                    mapContainerStyle={{ width: "100%", height: "300px" }}
                  >
                    <Marker 
                      position={newDriver.location}
                      icon={{
                        url: carGreen,
                        scaledSize: { width: 50, height: 50 },
                        anchor: { x: 25, y: 50 }
                      }}
                    />
                  </EnhancedGoogleMap>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DriverManagement;